<template>
	<div class="container" v-if='picUrl' v-on:click.stop='removePic'>
		<img :src="picUrl">
	</div>
</template>

<script scoped>
	import {mapGetters} from 'vuex'
	export default {
		name: 'bigPic',
		data () {
	    	return {
	    		picUrl: null
	    	}
	    },
		watch: {
			PICURL (newVal, oldVal) {
				this.picUrl = newVal
			}
		},
		computed: {
			...mapGetters('bigPic',{
				PICURL: 'picUrl'
			}),
		},
		methods: {
			removePic() {
				this.$store.dispatch('bigPic/removePic')
				.then(res => {
				}).catch(res => {
					console.log(res)
					this.$message.error('图片缩小失败，请刷新浏览器！')
				})
			}
		}
	};
</script>

<style type="text/less" lang="less" scoped>
	.container{
		z-index: 9999;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		background: rgba(0,0,0,0.4);
		img{
			position: absolute;
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			margin: auto;
			max-height: 90%;
			max-width: 90%;
			min-height: 60%;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/bigPic.vue